import { takeLatest } from "redux-saga/effects";

import * as Actions from "UserAuthorized/actionTypes";
import * as Action from "./action";
import * as Enum from "./enum";
import * as GoMagicLink from "./linksMagicLink";
import * as Security from "./security";

export default function* userSagas() {
  yield takeLatest(Actions.ACTION_SAVE_ACTION_REQUEST, Action.saveAction);
  yield takeLatest(Actions.ENUM_GET_ACTIONS_REQUEST, Enum.getActions);
  yield takeLatest(Actions.LINKS_GET_LINKS_REQUEST, GoMagicLink.getLinks);
  yield takeLatest(Actions.SECURITY_GET_USER_REQUEST, Security.getUser);
}
